import { setOptions, importLibrary } from "@googlemaps/js-api-loader";

// Set the options for loading the API.
setOptions({ key: "AIzaSyBP-Tpwni48KEKTGF3YaiWCjOupLT6vSf8" });

const initContactMaps = async (mapEls) => { 
    const { Map } = await google.maps.importLibrary('maps');
    const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');

    mapEls.forEach((el) => {
        // Get zoom data attr
        const zoom = parseFloat(el.dataset.zoom);

        // Get lat and lng data attrs
        const { lat } = el.dataset;
        const { lng } = el.dataset;

        const latLng = {
            lat: parseFloat(lat),
            lng: parseFloat(lng),
        };

        // Create gerenic map
        const mapArgs = {
            zoom: zoom || 16,
            center: latLng,
            mapId: 'cc814f174db119222c676c73',
            disableDefaultUI: true,
            backgroundColor: "#1F1414"
        };

        const map = new Map(el, mapArgs);

        // Create icon object. themeUrl set in enqueue.php with wp_localize
        const icon = document.createElement('img');
        icon.src = `${themeData.svgPath}lfs-marker.svg`;
        icon.classList.add('map-marker');

        // Create marker instance.
        const marker = new AdvancedMarkerElement({
            map,
            position: latLng,
            content: icon
        });

        setTimeout(() => {
            el.classList.add('loaded');
        }, 400);

        // Return map instance.
        return map;
    });
};

export default initContactMaps;
